let current = new Intl.DateTimeFormat(navigator.language, {
  hour12: false,
  hour: "numeric",
  month: "numeric",
})
  .format(new Date())
  .split(",");

let timeMonth = {
  hour: Number(current[1].trim()),
  month: Number(current[0].trim()),
};

export default timeMonth;
